import React, { useContext, useEffect, useState } from 'react'
import DataTable, { defaultThemes } from 'react-data-table-component'
import { useNavigate } from 'react-router-dom'
import { addcontext } from '../../ContextShare/ContextShare'
import language from '../../language.json'
import WatchNowLink from '../../Components/WatchNowLink'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import noResIll from '../../Assets/noResultIll.jpg'
import { Icon } from '@iconify/react/dist/iconify.js'
import Pagination from '../../Components/Pagination'

function TableBS({ getBsListData,erm ,handleResetFilter,count}) {
    const { paginationStartIndex, setPaginationStartIndex } = useContext(addcontext)
    const { paginationEndIndex, setPaginationEndIndex } = useContext(addcontext)
    const { archivesPaginationTotal, setarchivesPaginationTotal } = useContext(addcontext)
    const { archivesPaginationEnd, setarchivesPaginationEnd } = useContext(addcontext)
    const { archivesPaginationStart, setarchivesPaginationStart } = useContext(addcontext)
    const { paginationForGovernerAddress, setPaginationForGovernerAddress } = useContext(addcontext)
    const [paginationPerPage, setPaginationPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const { videoUrl, setVideoUrl } = useContext(addcontext)
    const { videoThumb, setVideoThumb } = useContext(addcontext)
    const { videoData, setVideoData } = useContext(addcontext)
    const { whichPageIsSendingData, setwhichPageIsSendingData } = useContext(addcontext)
    const [dataAvailable, setDataAvailable] = useState(false)
    const { langChanged, setlangChanged } = useContext(addcontext)
    const [currentLanguage, setCurrentLanguage] = useState();

    useEffect(() => {
        setCurrentLanguage(localStorage.getItem('language') || 'en')

    }, [currentLanguage, langChanged])

    const handleRowsPerPageChange = (newPerPage, page) => {
        console.log(`Pagination per page changed to ${newPerPage}`);
        setPaginationPerPage(newPerPage);
        setPaginationForGovernerAddress(newPerPage)
    };

    useEffect(() => {
        if (getBsListData) {
            setDataAvailable(false)
        }
        else {
            setDataAvailable(true)
        }
    }, [getBsListData])

    // useEffect to set dataAvailable to false after 5 seconds
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setDataAvailable(false);
        }, 5000); // 5000 milliseconds = 5 seconds

        // Cleanup function to clear the timeout when the component unmounts or when getBsListData changes
        return () => clearTimeout(timeoutId);
    }, [getBsListData]);
    const navigate = useNavigate()
    const handleWatchVideo = (e) => {
        setVideoUrl(e.video_url)
        setVideoThumb(e.video_thumbnail)
        setVideoData(e)
        if (e?.mapping_id) {
            console.log(e?.mapping_id);
            navigate(`/video/:${e?.mapping_id}`);
        }
    }
    
    // styles for tables
    const customStyles = {

        rows: {
            style: {
                '&:nth-child(odd)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '45px',


                },
                '&:nth-child(even)': {
                    backgroundColor: 'white',
                    minHeight: '45px'
                },
                '&:nth-child(1)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '45px'
                },
                '&:nth-child(2)': {
                    backgroundColor: 'white',
                    minHeight: '45px'
                },
            },
        },
        header: {
            style: {
                minHeight: '4px',

            },
        },
        headRow: {
            style: {
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default,
                backgroundColor: '#18A0FB',
                color: 'white',
                height: '40px',

            },
        },
        headCells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
        cells: {

            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,


                    // backgroundColor:'red'
                },
            },
        },


        // // when: row => row.year >= 2021,
        // style: {
        // 	backgroundColor: 'rgba(248, 148, 6, 0.9)',
        // 	color: 'white',
        // 	'&:hover': {
        // 		cursor: 'pointer',
        // 	},
        // },
    };
    
    // data for tables
    const columns = [
        {
            name: `${language.SlNo[currentLanguage]}`,
            selector: row => row.slno,
            sortable: true,
            minWidth: '70px',
            maxWidth: '80px',

        },
        {
            name: `${language.kla[currentLanguage]}`,
            selector: row => row.KLA,
            sortable: true,
            minWidth: '70px',
            maxWidth: '80px',
        },
        {
            name: `${language.Session[currentLanguage]}`,
            selector: row => row.Session,
            sortable: true,
            minWidth: '100px',
            maxWidth: '110px',
        },
        {
            name: `${language.Event[currentLanguage]}`,
            selector: row => row.Event,
            sortable: true,
            minWidth: '200px',
            maxWidth: '210px',
        },
        {
            name: `${language.Subject[currentLanguage]}`,
            selector: row => row.subject,
            sortable: true,
            minWidth: '200px',
            maxWidth: '210px',
        },
        {
            name: `${language.Minister[currentLanguage]}`,
            selector: row => row.Minister,
            sortable: true,
            minWidth: '200px',
            maxWidth: '210px',
        },
        {
            name: `${language.Date[currentLanguage]}`,
            selector: row => row.Date,
            sortable: true,
            minWidth: '100px',
            maxWidth: '110px',
        },
        {
            name: `${language.Download[currentLanguage]}`,
            selector: row => row.Download,
            minWidth: '100px',
            maxWidth: '110px',
            // sortable: true,
        }, {
            name: `${language.Watch_Now[currentLanguage]}`,
            selector: row => row.Action,
            minWidth: '100px',
            maxWidth: '110px',
            // sortable: true,
        },

    ];
    var data = []
    // iterate data to table
    getBsListData?.length > 0 && getBsListData.map((item, index) => {
        const id = index + 1; // Assuming ids start from 1
        const slno = id
        const KLA = item.kla;
        const Session = `${language.Session[currentLanguage]} ${item.video_session}`;
        const Event = currentLanguage == 'en' ? item?.video_event : item?.malayalam_video_event
        const subject = currentLanguage == 'en' ? item?.video_subject : item?.mal_video_subject
        const Minister = currentLanguage == 'en' ? item?.video_member : item?.malayalam_video_member;
        const Date = item.video_upload_date;
        const Download = <a href={item?.video_url} download target='_blank' style={{ color: '#18A0FB', cursor: 'pointer' }}>{language.Download[currentLanguage]}</a>;
        const Action = <WatchNowLink mappingId={getBsListData[index]?.mapping_id} onWatch={() => handleWatchVideo(getBsListData[index])}>{language.Watch_Now[currentLanguage]}</WatchNowLink>


        const newObj = { id, slno, KLA, Session, Event, Minister, Date, Download, Action, subject };
        data.push(newObj);
    })



    const calculateResultsCount = () => {
        const startIndex = (currentPage - 1) * paginationPerPage + 1;
        const endIndex = Math.min(currentPage * paginationPerPage, data.length);
        setarchivesPaginationStart(startIndex)
        setarchivesPaginationEnd(endIndex)
        setarchivesPaginationTotal(data.length)
        return `${startIndex}-${endIndex} of ${data.length}`;

    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    console.log(`Results showing: ${calculateResultsCount()}`); // Log results count



    return (
        <>

            {getBsListData?.length > 0 ?
             <div className='flex flex-col'>
                <DataTable
                    className='border mt-5'
                    columns={columns}
                    data={data}
                    customStyles={customStyles}
                    // pagination
                    paginationPerPage={paginationPerPage}
                    onChangeRowsPerPage={handleRowsPerPageChange}
                    onChangePage={handlePageChange} // Added onChangePage event
                    dense
                    highlightOnHover
                    selectableRowsHighlight
                    progressPending={dataAvailable}
                    paginationRowsPerPageOptions={[10, 50, 100, 200, 500]} // Options for users to change page size
                />
                {count>=10&&<Pagination count={count} />}
                </div>
                :
                <>
                    {(!erm && erm == undefined && erm == null) ? <div className='flex flex-col w-full gap-2'>
                        <Skeleton height={40} baseColor="#DCEFFF" highlightColor="#F5F8FA" />
                        <div className='flex flex-row gap-2 justify-between'>
                            <div className='w-3/12'>
                                <Skeleton count={7} />
                            </div>
                            <div className='w-3/12'>
                                <Skeleton count={7} />

                            </div>
                            <div className='w-3/12'>
                                <Skeleton count={7} />

                            </div>
                            <div className='w-3/12'>
                                <Skeleton count={7} />
                            </div>

                        </div>

                    </div> :
                         <div className='flex justify-center flex-col gap-5 items-center border-2 border-red-500'>
                         <div className='w-56 h-56'>
                             <img className='w-full h-full' src={noResIll} alt="" />
                         </div>
                         <p className='text-red-500 '>{erm}</p>
                         <button onClick={handleResetFilter} className='flex flex-row gap-1 items-center bg-white hover:bg-blue-500 border border-blue-500 text-blue-500 hover:text-white px-2 rounded mb-10 duration-500 ease-in-out'><Icon icon="ooui:clear" /><span>Clear Filter</span></button>
                     </div>

                    }
                </>
            }
        </>
    )
}

export default TableBS